<div class="payment-success-container">
  <div class="success-message">
    <img src="{{payment_image_url}}" alt="Success Icon" class="success-icon" />
    <h1>Thank You!</h1>
    <h2>Your payment has been successfully received.</h2>
    <p>
      Thank you for your payment. You have successfully registered with SmartAccuPay.
      Your registration credentials have been sent to your registered email address.
      Please click the "Login" button below and follow these steps:
    </p>
    <ol>
      <li>Change your temporary password on the first login and set a strong password for your account.</li>
      <li>Add an Approver user for your company. An Approver user is required to register vendors in SmartAccuPay.</li>
      <li>Add a default vendor for your company. A vendor is needed to process invoices and attach vendor details within
        the invoice data.</li>
      <li>User need to add mailbox set up, add IMAP setting for email account.</li>
    </ol>
    <p>
      For further assistance, contact SmartAccuPay Support at
      <a href="mailto:support@smartaccupay.com">support&#64;smartaccupay.com</a>.
    </p>
    <button mat-raised-button color="primary" (click)="goToHome()" class="auth-form-btn">Login</button>

  </div>
</div>